import React, { useState, useEffect } from "react";

function Table({ imageUrl }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    // Funkcja do pobierania danych z API
    console.log("imageUrl");
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://lublin-hydraulik.pl/stable-diffusion/reader.php?image=${imageUrl}`
        );
        const jsonData = await response.json();
        setData([jsonData]); // Zapisujemy dane z API do stanu komponentu
      } catch (error) {
        console.error("Błąd podczas pobierania danych z API:", error);
      }
    };

    fetchData();
  }, [imageUrl]); // Wywołujemy to tylko raz po pierwszym renderowaniu komponentu

  return (
    <div>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Prompt</th>
            <th>Negative prompt</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <>
              <tr key={index}>
                <td>{item.Prompt}</td>
                <td>{item["Negative prompt"]}</td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
      <table style={{ width: "100%", border: "1px solid black" }}>
        <thead>
          <tr>
            <th>Version</th>
            <th>Steps</th>
            <th>Sampler</th>
            <th>CFG scale</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <>
              <tr key={index}>
                <td>{item.Version}</td>
                <td>{item.Steps}</td>
                <td>{item.Sampler}</td>
                <td>{item["CFG scale"]}</td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
      <table style={{ width: "100%", border: "1px solid black" }}>
        <thead>
          <tr>
            <th>Seed</th>
            <th>Face rest</th>
            <th>Size</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <>
              <tr key={index}>
                <td>{item.Seed}</td>
                <td>{item["Face restoration"]}</td>
                <td>{item.Size}</td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
      <table style={{ width: "100%", border: "1px solid black" }}>
        <thead>
          <tr>
            <th>Model hash</th>
            <th>Model</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <>
              <tr key={index}>
                <td>{item["Model hash"]}</td>
                <td>{item.Model}</td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
